"use strict";

var _classCallCheck = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParticlesNumber = void 0;

var Density_1 = require("./Density");

var ParticlesNumber = /*#__PURE__*/function () {
  function ParticlesNumber() {
    _classCallCheck(this, ParticlesNumber);

    this.density = new Density_1.Density();
    this.limit = 0;
    this.value = 100;
  }

  _createClass(ParticlesNumber, [{
    key: "load",
    value: function load(data) {
      var _a;

      if (data === undefined) {
        return;
      }

      this.density.load(data.density);
      var limit = (_a = data.limit) !== null && _a !== void 0 ? _a : data.max;

      if (limit !== undefined) {
        this.limit = limit;
      }

      if (data.value !== undefined) {
        this.value = data.value;
      }
    }
  }, {
    key: "max",
    get: function get() {
      return this.limit;
    },
    set: function set(value) {
      this.limit = value;
    }
  }]);

  return ParticlesNumber;
}();

exports.ParticlesNumber = ParticlesNumber;